module.exports = __webpack_public_path__ + "img/0.43ed0488.png";